import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { featureReducer } from './auth.reducer';
import { EffectsModule } from '@ngrx/effects';
import { AuthStoreEffects } from './auth.effects';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature('auth', featureReducer),
    EffectsModule.forFeature([AuthStoreEffects])
  ]
})
export class AuthStoreModule { }
